<div class="row h-100">
  <div class="col-md-12">
    <i-title [text]="'lockedCourriers.lockedMails' | translate"></i-title>
  </div>
  @if (mails.length === 0) {
    <div class="col-md-12 viewerFull d-flex align-items-center justify-content-center">
      <img src="./assets/img/decoration/nofiles.svg " class="img-fluid" width="600" alt="" />
    </div>
  }
  @if (mails.length > 0) {
    <div class="col-md-6">
      <p-dropdown
        styleClass="w-100"
        [options]="types"
        [placeholder]="'lockedCourriers.filterByLockType' | translate"
        [showClear]="true"
        [(ngModel)]="mode">
      </p-dropdown>
    </div>
  }
  @if (mails.length > 0 && contactArray.length > 0 && isAdmin) {
    <div class="col-md-6">
      <p-multiSelect
        [options]="contactArray"
        [placeholder]="'lockedCourriers.filterByContact' | translate"
        (onChange)="filterContact($event)"
        styleClass="w-100"
        [virtualScroll]="true"
        virtualScrollItemSize="30">
      </p-multiSelect>
    </div>
  }
  @if (mails.length > 0) {
    <div class="col-md-12">
      <i-table
        [paginator]="true"
        class="super-table"
        [columns]="columns"
        (onClickRow)="goTo($event)"
        [items]="mails | filter: 'lockMode' : mode"
        id="locked-mails"
        [forselectionDefaultOption]="false"
        [search]="true"
        [forselection]="forselection"
        [multiselect]="true"
        [paginator]="true"
        [totalRecords]="totalRecords"
        [rows]="rows"
        [loading]="loading"
        [height]="'calc(100vh - 150px)'"
        [firstPage]="firstPage"
        (onPageChange)="lazyLoadData($event)"
        [lazy]="true"></i-table>
    </div>
  }
</div>
